import { esc } from '@/utils/escape';

export function generateProofTableHTML(data: any, settings: any): string {
  const headers = (data.headers || ["Kriterium", "Wir", "Andere"]).slice(
    0,
    3,
  );
  const hc = Number.isInteger(data.highlightColumn)
    ? data.highlightColumn
    : 1;

  const head = headers
    .map(
      (h: any, i: number) =>
        `<th class="${i === hc ? "is-highlight" : ""}">${esc(h)}</th>`,
    )
    .join("");
  const rows = (data.rows || [])
    .map(
      (r: any) => `
        <tr>
          <td>${esc(r.criterion || "")}</td>
          <td class="${hc === 1 ? "is-highlight" : ""}">${esc(r.us || "")}</td>
          <td class="${hc === 2 ? "is-highlight" : ""}">${esc(r.other || "")}</td>
        </tr>
  `,
    )
    .join("\n");

  return `  <!-- Proof Table -->
  <section class="proof" id="vergleich">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title || "")}</h2>
        <p>${esc(data.subtitle || "")}</p>
      </div>

      <div class="proof__table-wrap">
        <table class="proof__table">
          <thead><tr>${head}</tr></thead>
          <tbody>
${rows}
          </tbody>
        </table>
      </div>
    </div>
  </section>`;
}
